var render = function render(){
  var _vm$form, _vm$form$type, _vm$form$type$toLower;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', {
    staticClass: "desc-node"
  }, [_c('v-card-title', {
    class: `desc-node__title ${_vm.color} lighten-5`
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.title) + " ")]), _c('v-spacer'), _c('v-btn', {
    staticClass: "my-n2",
    attrs: {
      "small": "",
      "text": "",
      "icon": ""
    },
    on: {
      "click": _vm.pull
    }
  }, [_c('v-icon', [_vm._v(" mdi-trash-can-outline ")])], 1), _c('v-btn', {
    staticClass: "my-n2 mr-n2",
    attrs: {
      "small": "",
      "text": "",
      "icon": ""
    },
    on: {
      "click": _vm.exit
    }
  }, [_c('v-icon', [_vm._v(" mdi-close ")])], 1)], 1), _c('v-divider'), _c('v-card-text', [_c(`node-${(_vm$form = _vm.form) === null || _vm$form === void 0 ? void 0 : (_vm$form$type = _vm$form.type) === null || _vm$form$type === void 0 ? void 0 : (_vm$form$type$toLower = _vm$form$type.toLowerCase) === null || _vm$form$type$toLower === void 0 ? void 0 : _vm$form$type$toLower.call(_vm$form$type)}`, {
    tag: "component",
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }